webpackJsonp([0],{

/***/ "/agS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         msg: ''
      };
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "5Hwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[_c('div',{staticClass:"splash"},[_c('div',{staticClass:"splash-logo"},[_c('img',{staticClass:"text-logo",attrs:{"src":__webpack_require__("QdUu")}})])])])}]


/***/ }),

/***/ "8F2D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mobkast-logo-icon.1e49a96.png";

/***/ }),

/***/ "Bs5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []


/***/ }),

/***/ "GgDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("JBW2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08359db2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("zKrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("rlv3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08359db2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08359db2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08359db2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
   state: {},
   getters: {},
   mutations: {},
   strict: debug
}));

/***/ }),

/***/ "J5fL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("lGUq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b3b9ac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("5Hwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TD8M")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6b3b9ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b3b9ac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b3b9ac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JBW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Header',
   props: ['title'],
   data: function data() {
      return {};
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {},
      navigateToHome: function navigateToHome(ev) {
         window.location = '/';
      }
   }
});

/***/ }),

/***/ "KA8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EEC_vue__ = __webpack_require__("/agS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b975cab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EEC_vue__ = __webpack_require__("U/dK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("iC1C")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b975cab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EEC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b975cab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EEC_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b975cab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EEC_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6739b09a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Bs5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Qi+p")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6739b09a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6739b09a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash__ = __webpack_require__("0O0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Header_vue__ = __webpack_require__("GgDs");








var VueScrollTo = __webpack_require__("bm7V");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Vue plugins
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo, {
   container: "#landing",
   duration: 2600,
   easing: "ease",
   offset: -60,
   force: true,
   cancelable: true,
   onStart: false,
   onDone: false,
   onCancel: false,
   x: false,
   y: true
});

// * Load Components *

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('site-header', __WEBPACK_IMPORTED_MODULE_8__components_common_Header_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
   el: '#app',
   router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
   store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
   render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
   }
});

/***/ }),

/***/ "QVB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summit_vue__ = __webpack_require__("XEG2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738a9041_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summit_vue__ = __webpack_require__("sm2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jmXo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-738a9041"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738a9041_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summit_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738a9041_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summit_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QdUu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mobkast-logo-text.8cb5d3a.png";

/***/ }),

/***/ "Qi+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TD8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U/dK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('site-header',{attrs:{"title":"Engineering Enablement Command"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row"},[_c('h1',[_vm._v("\n         Engineering Enablement Command (EEC)\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         With large organizations taking on a multitude of software and technology initiatives to transform their organizations and augment their services, decision makers are faced with a host of underlying challenges that mirror product and engineering requirements normally associated with those of the top-tier tech companies.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Mobkast offers organization leaders a path to gracefully supercharge their transformation and growth efforts by offloading tough engineering problems to Mobkast's Engineering Enablement Command (EEC). EEC allows organizations to free up talent within customer organizations to focus primarily on the important work that is specific to the organization's unique offerings.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         EEC lets teams "),_c('span',{staticClass:"focus-bit"},[_vm._v("offload important considerations with regards to building and maintaining business critical systems, technology infrastructure and engineering processes")]),_vm._v(". This includes data ingestion pipelines, massively parallel compute engines, data storage and query optimization, cloud deployment and automation, third-party integrations, configuration management, information security and operational monitoring. The elite team of engineers at the EEC have successfully delivered on such transformational undertakings at growing and large organizations alike.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Mobkast's EEC is exceptional in its offering as it put strong emphasis on a direct customer interface with its architects and engineers at all stages of its customer engagement. This maximizes engagement efficacy and has been a principle element of the EEC members' approach to delivering on enablement projects involving substantial technical and organizational complexity.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Due to a limited nature of the talent sought after by Mobkast for the EEC, engagement is subject to availability. However, once engaged EEC offers a dedicated team to solidify your company's future-ready technical core that is otherwise costly to attain and even costlier to ignore.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n         To learn more about the Engineering Enablement Command reach out to "),_c('b',[_vm._v("team@mobkast.com")]),_vm._v(".\n      ")])])}]


/***/ }),

/***/ "XEG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         msg: ''
      };
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__ = __webpack_require__("J5fL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_EEC__ = __webpack_require__("KA8E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_site_Summit__ = __webpack_require__("QVB2");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
   routes: [{
      path: '/',
      name: 'Landing',
      component: __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__["a" /* default */]
   }, {
      path: '/summit',
      name: 'Summit',
      component: __WEBPACK_IMPORTED_MODULE_4__components_site_Summit__["a" /* default */]
   }, {
      path: '/eec',
      name: 'EEC',
      component: __WEBPACK_IMPORTED_MODULE_3__components_site_EEC__["a" /* default */]
   }, {
      path: '*',
      redirect: '/'
   }],
   mode: 'history'
}));

/***/ }),

/***/ "iC1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jmXo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Landing',
   components: {},
   data: function data() {
      return {
         msg: '',
         copyrightYear: new Date().getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false
      };
   },

   computed: {
      investorLabel: function investorLabel() {
         if (!this.investorContactVisible) {
            return 'INVESTORS';
         } else {
            // To avoid spam crawlers
            var team = 'investor';
            var domain = 'mobkast';
            var tld = 'com';
            return team + '@' + domain + '.' + tld;
         }
      }
   },
   methods: {
      preventMouseDown: function preventMouseDown(e) {},
      switchToInvestorContact: function switchToInvestorContact(ev) {
         this.investorLabelVisible = false;
         var vm = this;
         setTimeout(function () {
            vm.investorContactVisible = true;
         }, 1000);
      },
      navigateToDashX: function navigateToDashX(ev) {
         window.location = 'https://www.dashx.co';
      },
      scrollToElement: function scrollToElement(el) {
         this.$nextTick(function () {
            this.$scrollTo(el);
         });
      }
   }
});

/***/ }),

/***/ "rlv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sm2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('site-header',{attrs:{"title":"Summit - Enterprise Monitoring"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row"},[_c('h1',[_vm._v("Summit - Enterprise Monitoring")]),_vm._v(" "),_c('p',[_vm._v("\n         Summit is tailor-made unified monitoring, automation and analytics solution. Architectural components are designed to support enterprise automation, availability, performance, predictive and situation dashboard requirements.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Key Considerations")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("An operationally and functionally superior monitoring offering")]),_vm._v(" "),_c('li',[_vm._v("A modular solution to utilize the best available option for each component")]),_vm._v(" "),_c('li',[_vm._v("An ecosystem of technologies with promising future support and talent outlook")]),_vm._v(" "),_c('li',[_vm._v("An infrastructure and vendor agnostic design")]),_vm._v(" "),_c('li',[_vm._v("A maintenance and operationally optimized offering to reduce total cost of ownership")]),_vm._v(" "),_c('li',[_vm._v("An attractive investment path for future business requirements")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("High-Level Components")]),_vm._v(" "),_c('h3',[_vm._v("Collectors")]),_vm._v(" "),_c('p',[_vm._v("\n         System and process events, logs and telemetry collected from target systems form the raw data needed to generate alerts, trigger automation workflows, assess performance, enable predictive insights and power situational dashboards. Summit collectors support a vast array of data sources through mechanisms such as logs collection, webhooks and SNMP endpoints.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Ingest")]),_vm._v(" "),_c('p',[_vm._v("\n         The Summit solution interfaces with the collector through the Ingest component which allows for heterogenous events to be submitted through a single HTTP endpoint. This endpoint will accept multiple schemas to account for the diverse events sources across an enterprise's complex technology ecosystem.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Compute Engine")]),_vm._v(" "),_c('p',[_vm._v("\n         A core component of the Summit solution is the Summit Compute Engine. This component is powered by a best-in-class distributed compute engine. This engine powers a unified analytics engine for streaming and batch data processing.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Access Control")]),_vm._v(" "),_c('p',[_vm._v("\n         Access control and authorization is central to a multiuser environment. Summit uses Mobkast’s Fortress authorization engine which allows enterprise customers to describe user groups, access policies and a powerful tags schema to encapsulate many resource types. Fortress allows for powerful referencing to apply policies to tags or groups of tags using flexible patterns.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Automation")]),_vm._v(" "),_c('p',[_vm._v("\n         A monolithic automation service that satisfies a large set of enterprise automation requirements to include features such as auditing and RBAC, may present other challenges like requiring the deployment and managing of agents.\n\n         Summit allows for integration with a host of modern automation engines to best suit the specific needs of enterprise customers.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Dashboards and Workflows")]),_vm._v(" "),_c('p',[_vm._v("\n         An enterprise wide monitoring strategy and platform will demand a host of stakeholder specific workflows and dashbaords. Here Mobkast's DashX apps platform can be used to effectively deploy new workflows to support business and functional requirements. The DashX platform features a modular apps engine with a granular access control system to gracefully support separation of data and views for different stakeholders.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n         To learn more about deploying Summit in your organization reach out to "),_c('b',[_vm._v("team@mobkast.com")]),_vm._v(".\n      ")])])}]


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'app',
   data: function data() {
      return {
         msg: 'Mobkast - Elevate the ordinary.'
      };
   }
});

/***/ }),

/***/ "zKrh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"mobkast-icon-cell"},[_c('img',{staticClass:"mobkast-icon",attrs:{"src":__webpack_require__("8F2D")},on:{"click":_vm.navigateToHome}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu-container"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-title"},[_c('img',{staticClass:"text-logo",attrs:{"src":__webpack_require__("QdUu"),"width":"108px"}})])}]


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a74a9bfbd6da15dfe93f.js